import { render, staticRenderFns } from "./paidGolfInvoices.vue?vue&type=template&id=6b477a58&scoped=true"
import script from "./paidGolfInvoices.vue?vue&type=script&lang=js"
export * from "./paidGolfInvoices.vue?vue&type=script&lang=js"
import style0 from "./paidGolfInvoices.vue?vue&type=style&index=0&id=6b477a58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b477a58",
  null
  
)

export default component.exports